import { injectable } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { QuizSessionNavigationState } from '../../../api'

@injectable()
export class QuizSessionNavigationStateProtobufMapper {

  map(input: QuizSessionNavigationState): QuizSessionNavigationStateProtoMessage {
    return new QuizSessionNavigationStateProtoMessage({
      questionIndex: input.questionIndex,
      lastIndex: input.lastIndex
    })
  }

  deserialize(input: QuizSessionNavigationStateProtoMessage): QuizSessionNavigationState {
    return {
      questionIndex: input.questionIndex,
      lastIndex: input.lastIndex
    }
  }
}
@Type.d('QuizSessionNavigationStateProtoMessage')
export class QuizSessionNavigationStateProtoMessage extends Message<QuizSessionNavigationStateProtoMessage> {

  @Field.d(1, 'int32', "optional", 0)
  questionIndex: number

  @Field.d(2, 'int32', "optional", 0)
  lastIndex: number
}
